import React from "react";
import Layout from "../../../component/Layout";
import RRTestHeader from "./RRTestHeader";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import { Link } from "react-router-dom";

const RRTestResult2 = () => {
  return (
    <Layout>
      <div className="bg-[#f6f6f6] h-full">
        <div className="relative w-full max-w-2xl mx-auto h-full bg-[#f6f6f6] testbg pb-5 overflow-y-auto">
          <RRTestHeader />
          <div className="w-full max-w-2xl mx-auto px-5 pb-5">
            <div className="relative text-center mb-[58px]">
              <p className="text-black text-base font-normal">Test Results</p>
              <Link to="/rrtestresult1">
                <span className="absolute left-0 top-1/2 -translate-y-1/2">
                  <ArrowL />
                </span>
              </Link>
            </div>
            <div
              style={{ width: 174, height: 174 }}
              className="mx-auto mb-[30px]"
            >
              <CircularProgressbar
                strokeWidth={5}
                value={25}
                text={`${25}%`}
                styles={buildStyles({
                  textColor: "#000", // Text color
                  pathColor: "#BC0000", // Progress path color
                  trailColor: "#E5E5E5", // Background path color
                })}
              />
            </div>
            <div className="text-center">
              <p className="text-[#a5a5a5] text-xs font-normal uppercase mb-2">
                lorem ipsum
              </p>
              <span className="text-black text-sm font-normal capitalize">
                lorem ipsum
              </span>
              <button className="uppercase text-base font-semibold text-black p-6 w-full max-w-2xl mx-auto border border-black rounded-[70px] hover:opacity-70 mt-[72px]">
                retake test
              </button>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default RRTestResult2;

const ArrowL = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
    >
      <path
        d="M7 13L1 7L7 1"
        stroke="#000"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
